import React from "react";
import Requests from "../modules/Requests/Requests";

export default function RequestsPage() {
  return <Requests />;
}
